import { Select, SelectProps, Space, Tag } from 'antd';
import { useTranslate } from '@tolgee/react';
import { useEffect, useMemo, useState } from 'react';
import { sortBy } from 'lodash-es';
import isEqual from 'react-fast-compare';
import { queries } from 'services/queries';
import { useQuery } from '@tanstack/react-query';

export interface OperatorSelectProps extends Omit<SelectProps<any>, 'onChange'> {
  onChange: (value: any) => void;
}

function OperatorSelect(props: OperatorSelectProps) {
  const { value: valueProp, onChange: onChangeProp, onBlur, onClear, ...otherProps } = props;

  const { t } = useTranslate();

  const {
    data: list,
    isLoading: loading,
    error,
  } = useQuery({
    ...queries.accounts.userByPermission('VISIT_TODO_MANAGEMENT_CENTER'),
  });

  useEffect(() => {
    if (error) {
      t('phrase.获取数据失败，请稍后再试');
    }
  }, [error, t]);

  const options = useMemo(() => {
    return [
      {
        value: 0,
        label: t('todo.无受理客服'),
        filterKey: t('todo.无受理客服'),
      },
      ...sortBy(list, ({ status, sleepFlag }) => {
        if (status === 'DISABLE') {
          return 2;
        }
        if (sleepFlag) {
          return 1;
        }
        return 0;
      }).map(({ id, name, status, sleepFlag }) => {
        const tag = () => {
          if (status === 'DISABLE') {
            return <Tag>{t('ViewDashboard.客服状态.已停用')}</Tag>;
          }
          if (sleepFlag) {
            return <Tag color="orange">{t('ViewDashboard.客服状态.已休眠')}</Tag>;
          }
          return null;
        };

        return {
          label: (
            <Space size={6}>
              {name}
              {tag()}
            </Space>
          ),
          value: id,
          filterKey: name,
        };
      }),
    ];
  }, [list, t]);

  const [value, onChange] = useState(valueProp);

  useEffect(() => {
    onChange((value: any) => (isEqual(value, valueProp) ? value : valueProp));
  }, [valueProp]);

  return (
    <Select
      allowClear
      loading={loading}
      mode="multiple"
      maxTagCount="responsive"
      placeholder={t('department.请选择x', { x: t('todo.受理客服').toLowerCase() })}
      optionFilterProp="filterKey"
      options={options}
      className="max-w-[180px] min-w-[180px]"
      tagRender={({ label, value: cur, onClose }) => {
        return (
          <Tag
            closable
            onClose={(e) => {
              onClose(e);
              onChangeProp(value.filter((item: any) => item !== cur));
            }}
          >
            {label}
          </Tag>
        );
      }}
      value={value}
      onChange={onChange}
      onBlur={(e) => {
        if (!isEqual(value, valueProp)) {
          onChangeProp(value);
        }
        onBlur?.(e);
      }}
      onClear={() => {
        onChangeProp([]);
        onClear?.();
      }}
      {...otherProps}
    />
  );
}

export default OperatorSelect;
